import { Button, Col, Form, Input, Modal, Row, Space, theme, Upload } from "antd"
import React, { useEffect } from "react";
import { requiredItem, TYPE_MODAL } from "../../../constants/constants";
import { UploadOutlined } from "@ant-design/icons";
import { BASE_URL } from "../../../settings/config";

const ModalAddAndEdit = ({ visible, onCancel, onSave, data, title, type }) => {
    const [form] = Form.useForm();
    const { token } = theme.useToken();
    const [templateUrl, setTemplateUrl] = React.useState('');

    const formStyle = {
        maxWidth: 'none',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
    };
    const handleFinish = (values) => {
        if (type === TYPE_MODAL.ADD) {
            onSave({
                ...values,
                template_url: templateUrl
            });
        } else {
            let tempData = { ...values };
            tempData.id = data.id;
            if (templateUrl) {
                tempData.template_url = templateUrl;
            } else {
                tempData.template_url = data.template_url;
            }
            onSave(tempData);
        }
    };

    useEffect(() => {
        if (type === TYPE_MODAL.EDIT) {
            form.setFieldsValue({
                name: data.name ?? '',
                phone: data.phone ?? '',
                address: data.address ?? ''
            });
        } else {
            form.resetFields();
        }
    }, [data, type]);

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={onCancel}
            width={'50%'}
            footer={null}
        >
            <Form form={form} layout="vertical" name="add-edit-account" style={formStyle} onFinish={handleFinish}>
                <Row gutter={16}>
                    <Col span={14}>
                        <Form.Item
                            label="Tên nhà cung cấp"
                            name="name"
                            rules={requiredItem}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={10}>
                        <Form.Item
                            label="Số điện thoại"
                            name="phone"
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            label="Địa chỉ"
                            name="address"
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                </Row>
                {
                    data?.template_url && type === TYPE_MODAL.EDIT ? 
                        <Row gutter={16}>
                            <Col span={24}>
                                <a href={BASE_URL + data?.template_url} target="_blank" rel="noopener noreferrer">
                                    Link file mẫu excel
                                </a>
                            </Col>
                        </Row>
                        : null
                }
                <Row gutter={16}>
                    <Form.Item
                        label="Tải lên tệp"
                    >
                        <Upload
                            name="file"
                            listType="text"
                            beforeUpload={(file) => {
                                const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel';
                                if (!isExcel) {
                                    Modal.error({
                                        title: 'Định dạng không hợp lệ',
                                        content: 'Chỉ được phép tải lên file Excel (.xls, .xlsx)',
                                    });
                                }
                                return isExcel || Upload.LIST_IGNORE; // Chặn file không hợp lệ
                            }}
                            customRequest={async ({ file, onSuccess, onError }) => {
                                const formData = new FormData();
                                formData.append('file', file);

                                try {
                                    const response = await fetch(BASE_URL + 'upload_template', {
                                        method: 'POST',
                                        body: formData,
                                    });

                                    const result = await response.json();

                                    if (result.status === 1) {
                                        Modal.success({
                                            title: 'Tải lên thành công',
                                            content: result.msg,
                                        });
                                        setTemplateUrl(result.file_path);
                                        onSuccess(result); // Gọi callback thành công
                                    } else {
                                        Modal.error({
                                            title: 'Tải lên thất bại',
                                            content: result.msg,
                                        });
                                        onError(new Error(result.msg)); // Gọi callback thất bại
                                    }
                                } catch (error) {
                                    Modal.error({
                                        title: 'Lỗi',
                                        content: 'Không thể tải lên file. Vui lòng thử lại.',
                                    });
                                    onError(error); // Gọi callback thất bại
                                }
                            }}
                            multiple={false} // Chỉ cho phép tải lên một tệp
                        >
                            <Button icon={<UploadOutlined />}>Nhấn để tải lên</Button>
                        </Upload>
                    </Form.Item>

                </Row>

                <Row gutter={16} justify={'end'}>
                    <Space>
                        <Button onClick={onCancel}>
                            Hủy
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Lưu
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Modal>
    )
}
export default React.memo(ModalAddAndEdit);

